<template>
  <el-tooltip effect="dark" placement="top">
    <div slot="content">{{item.name}}<br/><small>{{parseTs(item.ctime)}}</small></div>
    <a @click="handleClick" href="#">
      <slot></slot>
    </a>
  </el-tooltip>
</template>

<style scoped>
a {
  text-decoration: none;
  color: #409EFF;
}
</style>


<script>
import moment from 'moment'

const WEBAPP_URL = process.env.WEBAPP_URL

const detailsPath = (item) => {
  switch (item.type) {
    case 'poi':
    case 'route':
    case 'track':
      return `#!/${item.type}-details/${item.data_name}?zoom=18`
    case 'videotrack':
      return `#!/${item.type}-details/${item.data_name}/0?zoom=true`
    case 'workfolder':
      return `#!/show-workfolder/${item.data_name}`
    default:
  }
}

export default {
  props: ['item'],
  methods: {
    async handleClick () {
      window.open(`${WEBAPP_URL}/${detailsPath(this.item)}`, '_blank')
    },
    parseTs (ts) {
      return moment(ts).format('LLL')
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/suggestions/PreviewLink.vue